/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_TitleInputs */

const en_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker Import`)
};

const fr_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des marqueurs`)
};

const de_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker-Import`)
};

const it_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione marcatore`)
};

const ru_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт маркеров`)
};

const es_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de marcadores`)
};

const zh_cn2_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记导入`)
};

const ja_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーのインポート`)
};

const hi_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर आयात`)
};

const pt_pt2_marker_import_title = /** @type {(inputs: Marker_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de Marcadores`)
};

/**
* | output |
* | --- |
* | "Marker Import" |
*
* @param {Marker_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_title = /** @type {((inputs?: Marker_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_title(inputs)
	if (locale === "de") return de_marker_import_title(inputs)
	if (locale === "it") return it_marker_import_title(inputs)
	if (locale === "ru") return ru_marker_import_title(inputs)
	if (locale === "es") return es_marker_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_title(inputs)
	if (locale === "ja") return ja_marker_import_title(inputs)
	if (locale === "hi") return hi_marker_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_title(inputs)
	return en_marker_import_title(inputs)
});